import * as axios from './Axios'

const PREFIX = 'analytics'

export const getAnalytics = (data) => axios.post(`admin/nudgpay-analytics`, data);
export const downloadAnalytics = (data) => axios.post(`admin/download-nudgpay-analytics`, data);
// export const getAnalytics = (data) => axios.post(`analytc`, data);
export const getAnalytics2024 = () => axios.get(`admin/link-payment-summary`);

export const _recordAnalytics = (data) => axios.post(`${PREFIX}/button-click`, data)
